import type { TFunction } from 'i18next';
import { FormItem } from '@ohpen/enso-ui';

type SelectOption = { label: string; value: string };
type RenderItem = FormItem['renderFormItem'];

const labels = 'lender.regionsBdms.labels';

export const getRegionSchema = (t: TFunction, renderWarning?: RenderItem): FormItem[] => [
  ...(renderWarning ? [{ renderFormItem: renderWarning }] : []),
  {
    title: `${labels}.name`,
    dataIndex: 'name',
    valueType: 'text',
    formItemProps: {
      rules: [{ required: true, whitespace: true, message: t(`${labels}.nameRequired`) }],
    },
    fieldProps: { maxLength: 100 },
  },
];

export const getBdmSchema = (
  t: TFunction,
  regionOptions: SelectOption[],
  renderHint?: RenderItem,
  renderWarning?: RenderItem,
): FormItem[] => [
  ...(renderWarning ? [{ renderFormItem: renderWarning }] : []),
  ...(renderHint ? [{ renderFormItem: renderHint }] : []),
  {
    title: `${labels}.name`,
    dataIndex: 'name',
    valueType: 'text',
    formItemProps: {
      rules: [{ required: true, whitespace: true, message: t(`${labels}.nameRequired`) }],
    },
    fieldProps: { maxLength: 100 },
  },
  {
    title: `${labels}.contactNumber`,
    dataIndex: 'contactNumber',
    valueType: 'text',
    formItemProps: {
      rules: [{ required: true, whitespace: true, message: t(`${labels}.contactNumberRequired`) }],
    },
    fieldProps: { maxLength: 100 },
  },
  {
    title: `${labels}.description`,
    dataIndex: 'description',
    valueType: 'textarea',
    fieldProps: { maxLength: 100 },
  },
  {
    title: `${labels}.linkedRegions`,
    dataIndex: 'regionIds',
    valueType: 'select',
    formItemProps: {
      rules: [{ required: true, type: 'array', min: 1, message: t(`${labels}.linkedRegionsRequired`) }],
    },
    fieldProps: { mode: 'multiple', options: regionOptions, optionFilterProp: 'label', allowClear: true },
  },
];

export const getReplaceSchema = (
  titleKey: string,
  requiredMessage: string,
  options: SelectOption[],
  renderExplanation?: RenderItem,
): FormItem[] => [
  ...(renderExplanation ? [{ renderFormItem: renderExplanation }] : []),
  {
    title: titleKey,
    dataIndex: 'replacementId',
    valueType: 'select',
    formItemProps: {
      rules: [{ required: true, message: requiredMessage }],
    },
    fieldProps: { options, optionFilterProp: 'label', showSearch: true },
  },
];
